import React, { useState } from 'react';

const AdminFinancialsEditFeeModal = ({ orderId, side, currentAmount, onConfirm, onClose }) => {
  const [amount, setAmount] = useState(currentAmount.toFixed(2));
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const label = side === 'ar' ? 'Title Company Fee' : 'Notary Fee';

  const handleConfirm = () => {
    const parsed = parseFloat(amount);
    if (isNaN(parsed) || parsed <= 0) {
      setError('Amount must be greater than $0');
      return;
    }
    if (!reason.trim()) {
      setError('Reason is required');
      return;
    }
    onConfirm(parsed, reason.trim());
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-xl border border-neutral-200 w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b border-neutral-200">
          <h2 className="text-base font-semibold text-neutral-800">Edit {label}</h2>
          <button onClick={onClose} className="text-neutral-400 hover:text-neutral-600 text-xl leading-none">&times;</button>
        </div>

        <div className="px-6 py-4 space-y-4">
          <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-sm text-amber-800">
            Editing the fee here does not regenerate the invoice. To change the fee and send a corrected invoice to the title company, use the fee editor on the order record, then return here and refresh before syncing to QuickBooks.
          </div>

          <p className="text-sm text-neutral-500">
            Order: <span className="font-medium text-neutral-700">{orderId}</span>
            {' · '}Current: <span className="font-medium text-neutral-700">${currentAmount.toFixed(2)}</span>
          </p>

          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              New Amount <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400 text-sm">$</span>
              <input
                type="number"
                min="0.01"
                step="0.01"
                value={amount}
                onChange={e => { setAmount(e.target.value); setError(''); }}
                className="w-full pl-7 pr-3 py-2 border border-neutral-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              Reason <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={reason}
              onChange={e => { setReason(e.target.value); setError(''); }}
              placeholder="e.g. Fee adjusted per agreement"
              className="w-full px-3 py-2 border border-neutral-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            />
          </div>

          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}
        </div>

        <div className="flex justify-end gap-2 px-6 py-4 border-t border-neutral-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-neutral-700 bg-neutral-100 hover:bg-neutral-200 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
          >
            Save Change
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminFinancialsEditFeeModal;
